export enum IdentityTypesEnum {
  POLICE_IDENTITY_CARD = 1,
  PASSPORT = 8,
  IDENTITY_CARD_FOR_MEMBERS_OF_THE_ARMED_FORCES_AND_SECURITY_FORCES = 24,
  RESIDENCE_PERMIT_FOR_THIRD_COUNTRY_NATIONALS = 25,
}
